module.exports = __webpack_public_path__ + "media/discovery-ui/assets/tab-option-illustrated-b8da5a2d299ec7ab22b32ca4c7507614.svg";